import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class FinancialResults extends ContentItem {
  _dataSetBody = null;

  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get year() {
    return get(this, '_rok.value', '');
  }

  get period() {
    return get(this, '_okres.value[0].codename', '');
  }

  get dataSet() {
    return get(this, '_dane.value[0].url', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/FinancialResults.model.js